interface HoveredAddButtonProps {
  title: string;
  onClick: () => void;
  className?: string;
}

export const HoveredAddButton: React.FC<HoveredAddButtonProps> = ({ title, className = "", onClick }) => {
  return (
    <div className={`flex justify-center w-full h-4 z-30 absolute cursor-pointer hovered-add-button ${className}`}>
      <div
        data-testid="add-content-hover-area"
        className="flex items-center size-full group pr-6 relative"
        onClick={onClick}
      >
        <div className="my-3 ml-80 border border-interactive-primary-default flex-1 group-hover:opacity-100 opacity-0 transition-opacity duration-200" />
        <div className="relative">
          <span className="bg-interactive-primary-default border border-interactive-primary-default rounded-xs px-2 py-1 opacity-0 whitespace-nowrap absolute top-[-14px] left-1/2 transform -translate-x-1/2 text-xs text-white group-hover:opacity-100 transition-opacity duration-200 z-50">
            {title}
          </span>
        </div>
        <div className="my-3 mr-80 border border-interactive-primary-default flex-1 group-hover:opacity-100 opacity-0 transition-opacity duration-200" />
      </div>
    </div>
  );
};
